import { Grid } from "@chakra-ui/react";
import React from "react";
import { useHistory } from "react-router-dom";
import Button from "../../../buttons/Button";
import {
  managerWhiteLabelSectionParams,
  managerWhiteLabelSections,
  managerWhiteLabelSubSections,
} from "../../../defines";
import { PrincipalTeamItem } from "../../common/principals/PrincipalOverview/PrincipalTeamItem";
import { ManagerProfileDivider } from "../ManagerProfileDivider";
import { ManagerProfileEmptySection } from "../ManagerProfileEmptySection";
import {
  ManagerProfileEditingSection,
  useManagerProfile,
} from "../ManagerProfileProvider";
import { ManagerProfileSection } from "../ManagerProfileSection";

export const Team: React.FC<{
  onShowKeyPeopleOnDashboard?: () => void;
}> = ({ onShowKeyPeopleOnDashboard }) => {
  const history = useHistory();

  const {
    manager,
    isEditing,
    isPublic,
    setEditingDrawer,
    setEditingTargetData,
    buildManagerProfileRouteUrl,
  } = useManagerProfile();

  const dataPrincipals = manager.principals || [];

  const hasMembers =
    (manager.managerEmployees?.length || 0) > 0 ||
    (manager.principals?.length || 0) > 0;

  if (!isEditing && (!hasMembers || dataPrincipals.length === 0)) return <></>;

  const managerEmployees = manager.managerEmployees || [];
  const principals = (isPublic ? dataPrincipals : manager.principals) || [];
  const onPrincipalDetail = async (teamId: string) => {
    if (isEditing) {
      await setEditingTargetData({ id: teamId });
      setEditingDrawer(ManagerProfileEditingSection.Team);
      return;
    }

    history.push(
      buildManagerProfileRouteUrl({
        [managerWhiteLabelSectionParams.section]:
          managerWhiteLabelSections.overview,
        [managerWhiteLabelSectionParams.subSection]:
          managerWhiteLabelSubSections.principal,
        [managerWhiteLabelSectionParams.subSectionId]: teamId,
      }),
      { modalScrollY: window.scrollY },
    );
  };

  const onShowKeyPeople = () => {
    if (isEditing && onShowKeyPeopleOnDashboard) {
      onShowKeyPeopleOnDashboard();
      return;
    }

    history.push(
      buildManagerProfileRouteUrl({
        [managerWhiteLabelSectionParams.section]:
          managerWhiteLabelSections.overview,
        [managerWhiteLabelSectionParams.subSection]:
          managerWhiteLabelSubSections.keyPeople,
      }),
      { modalScrollY: window.scrollY },
    );
  };

  return (
    <>
      <ManagerProfileDivider />
      <ManagerProfileSection
        w={"100%"}
        title={"Team"}
        action={() => setEditingDrawer(ManagerProfileEditingSection.Team)}
      >
        {isEditing && !hasMembers && (
          <ManagerProfileEmptySection
            description={
              "Help investors get to know you and your team by providing their information on your profile."
            }
            buttonLabel={"Add team members"}
            onAction={() => setEditingDrawer(ManagerProfileEditingSection.Team)}
          />
        )}
        {manager && (!isEditing || hasMembers) && (
          <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={8}>
            {principals &&
              principals.map((p) => {
                return (
                  <PrincipalTeamItem
                    isEditing={isEditing}
                    manager={manager}
                    key={p.id}
                    principal={p}
                    cursor="pointer"
                    onClick={() =>
                      onPrincipalDetail(
                        (isEditing
                          ? String(p.id || "")
                          : p.slug || String(p.id || "")) || "",
                      )
                    }
                    cta
                  />
                );
              })}
          </Grid>
        )}
        {managerEmployees && managerEmployees.length > 0 && (
          <Button
            mt="48px"
            bg="transparent"
            isLarge
            label="Show key people"
            onClick={onShowKeyPeople}
            outline
          />
        )}
      </ManagerProfileSection>
    </>
  );
};
